export const API_URL = `${window._env_.GOPLAN_BACKEND_API_URL || import.meta.env.VITE_BACKEND_API_URL}v1`;

export const IMPORT_API_URL = `${window._env_.GOPLAN_BACKEND_API_URL || import.meta.env.VITE_BACKEND_API_URL}v2`;

export const AUTH_API_URL =
  window._env_.GOPLAN_AUTH_API_URL || import.meta.env.VITE_AUTH_API_URL || 'http://10.10.7.143:8181/';
